import axiosInstance from '../services/AxiosInstance';

export function getBanks(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`bank?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}&${filterQuery}`);
}

export function getAllBanks(filterQuery = "") {
    return axiosInstance.get(`bank?noPagination=true&${filterQuery}`);
}

export function deleteBank(id) {
    return axiosInstance.delete(`bank/${id}`);
}

export function createBank(data) {
    return axiosInstance.post(`bank`,data);
}

export function updateBank(id, data) {
    return axiosInstance.put(`bank/${id}`,data);
}
